module.exports = __webpack_public_path__ + "static/img/ota-img.d978f3f2.png";